import { CitySelection } from "./sessions/bulk/city";
export class ProvinceMultiple {
    constructor(provinceContainer) {
        this.provinceContainer = provinceContainer;
        this.provinceId = provinceContainer.dataset.id;
        const button = provinceContainer.querySelector(ProvinceMultiple.citiesButtonSelector(this.provinceId));
        this.selectAllCheckbox =
            this.provinceContainer.querySelector(ProvinceMultiple.selectAllCitiesCheckboxSelector);
        this.selectAllCheckbox.addEventListener("change", () => {
            this.cities.then((cities) => {
                cities.forEach((city) => {
                    city.selected = this.selectAllCheckbox.checked;
                });
            });
        });
        this.url = new URL(button.dataset.url, `${location.protocol}//${location.host}`);
        button.addEventListener("click", () => {
            this.cities;
        });
        this.selectedCitiesNumber = this.provinceContainer.querySelector(ProvinceMultiple.citiesSelectedNumberSelector);
    }
    get cities() {
        if (!this._cities) {
            this._cities = this.fetchCities();
            this._cities.then(() => {
                this.addCitiesToDom();
                this.updateSelectedCities();
            });
        }
        return this._cities;
    }
    fetchCities(page = 1, cities = []) {
        return new Promise((resolve, reject) => {
            this.selectedCitiesNumber.innerHTML =
                '<i class="fas fa-spinner fa-pulse"></i>';
            fetch(this.urlFetchCities(page).toString())
                .then((response) => response.json())
                .then((json) => {
                cities = [...cities, ...json.data];
                if (json.more) {
                    this.fetchCities(page + 1, cities)
                        .then(resolve)
                        .catch(reject);
                }
                else {
                    resolve(this.createCitiesSelections(cities));
                }
            })
                .catch(reject);
        });
    }
    createCitiesSelections(cities) {
        return cities.map((city) => new CitySelection(city, () => {
            this.updateSelectedCities();
        }));
    }
    urlFetchCities(page) {
        const url = new URL(this.url);
        url.searchParams.set("regionId", this.provinceId);
        url.searchParams.set("page", page.toString());
        return url;
    }
    addCitiesToDom() {
        const citiesWrapper = this.provinceContainer.querySelector(ProvinceMultiple.citiesWrapperSelector);
        citiesWrapper.innerHTML = "";
        this.cities.then((cities) => {
            cities.forEach((city) => {
                citiesWrapper.appendChild(city.domElement());
            });
        });
    }
    updateSelectedCities() {
        this.cities.then((cities) => {
            const selectedCities = cities.filter((city) => city.selected);
            if (selectedCities.length === 0) {
                this.selectAllCheckbox.checked = false;
            }
            else if (selectedCities.length === cities.length) {
                this.selectAllCheckbox.checked = true;
            }
            else {
                this.selectAllCheckbox.indeterminate = true;
            }
            this.selectedCitiesNumber.innerHTML = `${String(selectedCities.length)} / ${cities.length}`;
        });
    }
}
ProvinceMultiple.provinceContainerSelector = ".js-province";
ProvinceMultiple.citiesButtonSelector = (provinceId) => `.js-show-cities-button-${provinceId}`;
ProvinceMultiple.citiesWrapperSelector = ".js-cities-body";
ProvinceMultiple.citiesSelectedNumberSelector = ".cities_selected";
ProvinceMultiple.selectAllCitiesCheckboxSelector = ".js-all-cities";
